import { useEffect } from "react";

/**
 * On mobile, profile and admin layouts stack the sidebar above the main column.
 * Match sidebar link behaviour: prime scroll so the main pane scrolls into view after navigation.
 */
function pathOnlyFromTo(to) {
  if (typeof to === "string") return to.split("?")[0].split("#")[0];
  const p = to?.pathname || "";
  return String(p).split("?")[0].split("#")[0];
}

export function primeMobileDashboardContentScroll(to) {
  if (typeof window === "undefined" || window.innerWidth >= 1024) return;
  const base = pathOnlyFromTo(to);
  if (
    base.startsWith("/profile/") ||
    base.startsWith("/admin/") ||
    base.startsWith("/admin-")
  ) {
    sessionStorage.setItem("dashboardScrollToContent", "1");
  }
}

export function navigateWithMobileDashboardScroll(navigate, to, options) {
  primeMobileDashboardContentScroll(to);
  navigate(to, options);
}

/** Scroll a page section into view on mobile (e.g. order details after table row tap). */
export function useScrollToRefOnMobile(ref, trigger) {
  useEffect(() => {
    if (typeof window === "undefined" || window.innerWidth >= 1024) return;
    const timer = window.setTimeout(() => {
      ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 120);
    return () => window.clearTimeout(timer);
  }, [ref, trigger]);
}
